import { ScrEnvironment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ScrBaseService } from './base.service';
import { ScrServiceManager } from './servicemanager.service';
import { octetStreamDownload } from './authentication.service';

@Injectable({
    providedIn: 'root'
})
export class ReportsService extends ScrBaseService {

    constructor(
        serviceManager: ScrServiceManager,
        private environment: ScrEnvironment,
        private http: HttpClient) {
        super(serviceManager);
    }

    downloadShortCodeExpiration(dateRange:string): Observable<HttpResponse<Blob>> {
        const url = `${this.environment.base}/secure2/customerreports/shortcodeexpiration?type=${dateRange}`;
        return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
    }

    downloadShortCodeList() {
        const url = `${this.environment.base}/secure2/customerreports/shortcodelist`;
        return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
    }

    downloadBrandList() {
        const url = `${this.environment.base}/secure2/customerreports/brandlist`;
        return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
    }

    downloadContentProviderList() {
        const url = `${this.environment.base}/secure2/customerreports/contentProviderlist`;
        return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
    }

    downloadShortCodeBrand() {
        const url = `${this.environment.base}/secure2/customerreports/shortcodebrand`;
        return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
    }

    downloadPaymentSummary(type: string,retrieveBy:string, start?: string, end?: string, unpaidInvoices?: boolean) {
        let url;
        if (start && end)
         url = `${this.environment.base}/secure2/customerreports/paymentsummary?type=${type}&unpaidInvoices=${unpaidInvoices}&startDate=${start}&endDate=${end}&retrieveBy=${retrieveBy}`;
         else if(start)
         url = `${this.environment.base}/secure2/customerreports/paymentsummary?type=${type}&unpaidInvoices=${unpaidInvoices}&startDate=${start}&retrieveBy=${retrieveBy}`;
         else if(end)
         url = `${this.environment.base}/secure2/customerreports/paymentsummary?type=${type}&unpaidInvoices=${unpaidInvoices}&endDate=${end}&retrieveBy=${retrieveBy}`;
         else 
         url = `${this.environment.base}/secure2/customerreports/paymentsummary?type=${type}&unpaidInvoices=${unpaidInvoices}&retrieveBy=${retrieveBy}`;
        return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
    }
    downloadShortCodeTransfer(type: string, start?: string, end?: string) {
        let url;
        if (start && end)
         url = `${this.environment.base}/secure2/customerreports/shortcodetransfers?type=${type}&startDate=${start}&endDate=${end}`;
         else 
         url = `${this.environment.base}/secure2/customerreports/shortcodetransfers?type=${type}`;
        return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
    }

    downloadOriginalShortCodeListWithContentProviders() {
        const url = `${this.environment.base}/secure2/customerreports/shortcodelistoriginal`;
        return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
    }

}

